import React, { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, MenuItem, Select } from '@material-ui/core';

import { ClientFollowMappingFragment, useUpdateClientFollowMappingMutation } from 'api';
import { useNotify } from 'hooks';
import { useUpdateClientFollowMapping } from 'features/admin/updaters';

interface IProps {
  mapping: ClientFollowMappingFragment;
}

const ConjunctionsEdit: FC<IProps> = ({ mapping }) => {
  const notify = useNotify();
  const { t } = useTranslation();

  const mutationOptions = useUpdateClientFollowMapping();
  const { mutate } = useUpdateClientFollowMappingMutation({
    onSuccess: editNotify,
    ...mutationOptions,
  });

  function editNotify() {
    const message = t('components:savedSuccessfully');
    notify.info({ message });
  }

  function getRequiredValues() {
    const { id, title, mapping_status, all_users, follow_conditions } = mapping;
    const { department_id, location_id } = follow_conditions;

    return {
      id,
      title,
      mapping_status,
      all_users,
      follow_conditions: {
        department_id,
        location_id,
      },
    };
  }

  function handleChange(conjunction: number) {
    const followConditionConjunction = !!conjunction;
    return mutate({
      data: {
        ...getRequiredValues(),
        follow_condition_conjunction: followConditionConjunction,
      },
    });
  }

  return (
    <Grid container>
      <Grid item xs={3}></Grid>
      <Grid item xs={2}>
        <Box mt={2} mb={2}>
          <Select
            fullWidth
            value={mapping.follow_condition_conjunction ? 1 : 0}
            onChange={(event: ChangeEvent<HTMLSelectElement>) =>
              handleChange(parseInt(event.target.value, 10))
            }
          >
            <MenuItem value={0}>{t('admin:or')}</MenuItem>
            <MenuItem value={1}>{t('admin:and')}</MenuItem>
          </Select>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ConjunctionsEdit;
